export default {
  ATOM: 'atom',
  MOLECULE: 'molecule',
  ORGANISM: 'organism',
  TEMPLATE: 'template',
  PAGE: 'page',
};
